export default __webpack_public_path__ + "static/media/3046.d1b7ea8a.jpg";